import { Redirect, Route, RouteProps } from 'react-router';
import { useAuth } from '../../context';

export const AuthenticatedRoute = (props: RouteProps<string>) => {
    const { user } = useAuth()
    if (!user)
        return <Redirect to="/login" />

    return <Route {...props} />
}